import { Store } from '../redux/Store';
export * from './actions/Api';
export * from './actions/General';

// Action Types
export const SET_ACTIVE_SCREEN = 'set_active_screen';
export const SET_JOB = 'set_job';
export const GET_JOB = 'get_job';
export const SET_PHONE = 'set_phonenumber';
export const SET_PROFILE = 'set_profile';
export const SET_TOKEN = 'set_token';
export const SET_FIREBASE_TOKEN = 'set_firebase_token';
export const GET_FIREBASE_TOKEN = 'get_firebase_token';
export const SET_ACTIVE_JOB = 'set_active_job';
export const SET_BIDS = 'set_bids';
export const SET_BID = 'set_bid';
export const SET_MESSAGES = 'set_messages';
export const SET_CHAT_MESSAGES = 'set_chat_messages';
// Actions
export const setActiveScreen = screen => {
   return ({ type: SET_ACTIVE_SCREEN, payload: { screen } });
};

export const setBid = (bid) => {
   return { type: SET_BID, payload: bid };
};

export const setBids = (bids) => {
   return { type: SET_BIDS, payload: bids };
};

export const setJob = (job) => {
   //Store.dispatch({type: SET_JOB, payload: job});
   return { type: SET_JOB, payload: job };
};

export const getJob = () => {
    return { type: GET_JOB };
};

export const getFirebaseToken = () => {
   return {type:  GET_FIREBASE_TOKEN };
};

export const setPhone = (phone) => {
   return ({ type: SET_PHONE, payload: phone });
};

export const setActiveJob = (job) => {
   return (dispatch, getState) => {
       //console.log('setActiveJob', job);
       dispatch({ type: SET_ACTIVE_JOB, payload: job });
   };
}

export const setMessages = (messages) => {
   return (dispatch, getState) => {
       //console.log('setMessages', messages);
       dispatch({ type: SET_MESSAGES, payload: messages });
   };
}

export const setChatMessages = (messages) => {
   return (dispatch, getState) => {
       //console.log('setChatMessages', messages);
       dispatch({ type: SET_CHAT_MESSAGES, payload: messages });
   };
}

export const setProfile = (profile) => {
   return (dispatch, getState) => {
       //console.log('setProfile', profile);
       dispatch({ type: SET_PROFILE, payload: profile });
   };
};

export const setToken = (token) => {
   return (dispatch, getState) => {
       //console.log('setToken', token);
       dispatch({ type: SET_TOKEN, payload: token });
   };
};

export const setFirebaseToken = (token) => {
   return (dispatch, getState) => {
       //console.log('setFirebaseToken', token);
       dispatch({ type: SET_FIREBASE_TOKEN, payload: token });
   };
};